import api from "./axios";
import type { CreatePaymentType } from "@/struct/PaymentStruct";
import type { ApiResponseEnvelope } from "@/struct/ApiEnvelope";
import type { AccountPhoneType } from "@/struct/AccountPhoneStruct";

export default class CustomerService {
  changeMainCustomer = (newMainCustomerMsisdn: string) => {
    return api.post("/api/mobile/account/change-main-customer", {
      new_customer_msisdn: newMainCustomerMsisdn.toString(),
    });
  };

  getChildAccounts = () => {
    return api.get<ApiResponseEnvelope<AccountPhoneType[]>>(
      "/api/mobile/account/get-child-accounts"
    );
  };

  createPayment = (payload: CreatePaymentType) => {
    return api.post<ApiResponseEnvelope<{ REF: string }>>(
      "/api/web-api/web/create-payment",
      payload
    );
  };
}
